import { request } from '@langlois/request';

export async function sendInvitation ({ commit }, values) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/team/invite`);

		const data = new FormData();
		[`email`, `clubId`].forEach(d => data.append(d, values[d]));

		const response = await request.post(url, data);

		if (!response.ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while sending the invitation.`,
			type: `warning`
		}, { root: true });

		commit(`vcl/notificationBar/show`, {
			text: `Invite sent to ${values.email}.`,
			type: `success`
		}, { root: true });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while sending the invitation.`,
			type: `warning`
		}, { root: true });
	}
}
